import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoutes from './utils/PrivateRoutes'
import LoginComponent from "./components/login_component";
import ForgotPasswordComponent from "./components/forget_password";
import ResetPassword from './components/reset_password';
import MainComponent from './utils/main_component';

const AppRouter = () => {
    return (
        <Routes>
            <Route path='/' element={<LoginComponent />} />
            <Route path='forgot-password' element={< ForgotPasswordComponent/>} />
            <Route path='reset-password/:token' element={< ResetPassword/>} />

            <Route element={<PrivateRoutes />}>
                <Route path='/*' element={<MainComponent />} />
            </Route>
        </Routes>
    )
}

export default AppRouter;